export const setEmployeeInfo=(data)=>{
    return {
        type: "SET_EMPLOYEE_INFO",
        info: data,
    }
}
export const nullEmployeeInfo=()=>{
    return{
        type:"NULL_EMPLOYEE_INFO",
        info: null
    }
}
export const getEmployeeInfo=()=>{
    return {
        type: "GET_EMPLOYEE_INFO",
        
    }
}
